/*
  !IMPORTANT!: This file will be deleted in the future!
  If you want to use this functionality, please rather turn your *.vue file into a composition API and directly use the `useContactSupport` composable instead.
  This file is only kept for backwards compatibility for old *.vue files that are still using options API and mixins.

  If you want to change the branding functionality, please do it in this mixin AND the composable!
*/

// this mixin is created to be one point of managing contact support feature flag for logged in and non-logged-in users
const contactSupportMixin = {
  computed: {
    canContactSupport () {
      const schoolProps = this.$me?.school?.properties || this.$store.state.school?.meta?.properties
      if (!schoolProps) return false
      return !!schoolProps['sdui_contact.support.enabled']
    }
  }
}

export default contactSupportMixin
